import React from "react";

import { Footer } from "components/Footer";
import { Header } from "components/Header";
import ContentContainer from "components/Container";

export const Page = ({ children, ...props }) => {
  return (
    <div
      style={{
        maxWidth: '48rem',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
      {...props}
    >
      <Header />
      <div>
        <ContentContainer>{children}</ContentContainer>
      </div>
      <Footer />
    </div>
  );
};
